
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class OnlyTwo extends Vue {
  @Prop() gallery!: Array<any>;
}
